import { orderDomainStore } from '../../store';
export const getOrderTicketRedemptionCardRedemptionDetails = (ticketRedemptionCardId) => {
    const details = orderDomainStore.data.orderTicketRedemptionCardRedemptionDetailsById[ticketRedemptionCardId];
    if (!details) {
        throw new Error(`Cannot find redemption details for ticket redemption card with ID: '${ticketRedemptionCardId}'.`);
    }
    return details;
};
